import { useTranslation } from 'react-i18next';
import useAppModal from 'hooks/useAppModal';
import useNotify from 'hooks/useNotify';
import useAppMutation from 'hooks/useAppMutation';
import API from 'services/API';
import { useSelectModeContext } from '../../context/SelectModeContext';
import useInvalidatePropertyPhotos from '../../hooks/useInvalidatePropertyPhotos';
import usePropertyPhotosData from '../../hooks/usePropertyPhotosData';

export const DELETE_SELECTED_PHOTOS_MUTATION_KEY = ['delete-selected-photos'];

const useDeleteSelectedPhotos = () => {
  const { t } = useTranslation();
  const { notifyError } = useNotify();
  const { selectedPhotos, toggleSelectMode } = useSelectModeContext();
  const { openConfirmModal } = useAppModal();

  const { invalidatePropertyPhotos } = useInvalidatePropertyPhotos();
  const { getPhotos } = usePropertyPhotosData();

  const { mutateAsync: deleteSelectedPhotos } = useAppMutation(
    DELETE_SELECTED_PHOTOS_MUTATION_KEY,
    ({ photoUids }: { photoUids: string[] }) => {
      return API.delete(`/api/v3.2/photos?photoUids=${photoUids.join(',')}`);
    },
  );

  const deletePhotos = async () => {
    try {
      await deleteSelectedPhotos({
        photoUids: Array.from(selectedPhotos),
      });
    } catch (error) {
      notifyError(t('pageProperty.photos.deleteSelectedModal.error'));
    } finally {
      const photosLength = getPhotos().length;
      const selectedPhotosCount = selectedPhotos.size;

      selectedPhotos.clear();
      if (selectedPhotosCount >= photosLength) {
        toggleSelectMode();
      }
      invalidatePropertyPhotos();
    }
    // } finally {
    //   // if there are no photos left, we should be out of the select mode
    //   console.log('getPhotos().length', getPhotos().length);
    //   selectedPhotos.clear();
    //   if (getPhotos().length === 0) {
    //     toggleSelectMode();
    //   }
    //   invalidatePropertyPhotos();
    // }
  };

  const handleDelete = () => {
    openConfirmModal({
      title: t('pageProperty.photos.deleteSelectedModal.title', {
        count: selectedPhotos.size,
      }),
      body: t('pageProperty.photos.deleteSelectedModal.description', {
        count: selectedPhotos.size,
      }),
      onConfirm: () => {
        deletePhotos();
      },
      confirmColor: 'danger',
      confirmLabel: t('common.delete'),
    });
  };

  return { handleDelete };
};

export default useDeleteSelectedPhotos;
